export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ممنوع الدخول"])}
        }
      },
      "ar-EG": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ممنوع الدخول"])}
        }
      },
      "ar-SA": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ممنوع الدخول"])}
        }
      },
      "de-DE": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kein Eintrag"])}
        }
      },
      "de-AT": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kein Eintrag"])}
        }
      },
      "de-CH": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kein Eintrag"])}
        }
      },
      "en-US": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No entry"])}
        }
      },
      "en-GB": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No entry"])}
        }
      },
      "it-IT": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vietato l'ingresso"])}
        }
      },
      "fr-FR": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrée interdite"])}
        }
      },
      "es-ES": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No hay entrada"])}
        }
      },
      "pl-PL": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brak wejścia"])}
        }
      },
      "nl-NL": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geen toegang"])}
        }
      },
      "bg-BG": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Не е вход"])}
        }
      },
      "bs-BA": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zabranjen ulaz"])}
        }
      },
      "da-DK": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingen adgang"])}
        }
      },
      "et-EE": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sissepääs puudub"])}
        }
      },
      "fi-FI": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ei sisäänkäyntiä"])}
        }
      },
      "el-GR": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Απαγορεύεται η είσοδος"])}
        }
      },
      "he-IL": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אין כניסה"])}
        }
      },
      "ga-IE": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gan iontráil"])}
        }
      },
      "ja-JP": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["立入り禁止"])}
        }
      },
      "hr-HR": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zabranjen ulaz"])}
        }
      },
      "lv-LV": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iebraukt aizliegts"])}
        }
      },
      "lt-LT": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nėra įėjimo"])}
        }
      },
      "pt-PT": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrada proibida"])}
        }
      },
      "ro-RO": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nicio intrare"])}
        }
      },
      "ru-RU": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нет входа"])}
        }
      },
      "sv-SE": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingen ingång"])}
        }
      },
      "sk-SK": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zákaz vstupu"])}
        }
      },
      "cs-CZ": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vstup zakázán"])}
        }
      },
      "tr-TR": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Giriş yok"])}
        }
      },
      "hu-HU": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Belépni tilos"])}
        }
      },
      "fr-BE": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrée interdite"])}
        }
      },
      "fr-LU": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrée interdite"])}
        }
      },
      "mt-MT": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L-ebda dħul"])}
        }
      },
      "sl-SI": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ni vstopa"])}
        }
      },
      "el-CY": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Απαγορεύεται η είσοδος"])}
        }
      },
      "tr-CY": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Giriş yok"])}
        }
      },
      "uk-UA": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kein Eintrag"])}
        }
      },
      "zh-CN": {
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "undefined": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "inactive": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "noEntry": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["禁止入内"])}
        }
      }
    }
  })
}
